const state = {
    current_state: 'qld'
};

const getters = {
    getCurrentState: state => {
        if (!['act', 'nsw', 'nt', 'qld', 'sa', 'tas', 'vic', 'wa'].includes(state.current_state)) return false
        return state.current_state;
    }
};

const mutations = {
    setCurrentState(state, current_state) {
        state.current_state = current_state;
    }
};

const actions = {
    saveCurrentState(context, current_state) {
        context.commit("setCurrentState", current_state);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
